import { render, staticRenderFns } from "./StudentRankType.vue?vue&type=template&id=60a65346"
import script from "./StudentRankType.vue?vue&type=script&lang=js"
export * from "./StudentRankType.vue?vue&type=script&lang=js"
import style0 from "./StudentRankType.vue?vue&type=style&index=0&id=60a65346&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports